export default "__VITE_ASSET__fa10e5e0__"